import {colorPalette} from '~/components/scene/definitions/color-palette';
import {getIdForNextElement} from '../../../utils/common';

export const createSlide = image => ({
  backgroundType: 'flow',
  slideWidth: 1,
  justifyContent: 'center',
  id: getIdForNextElement(),
  image,
  bgColor: colorPalette[0][0],
});
